import React from 'react';
import { ClipLoader } from 'react-spinners';
import './onboarding.scss';

const OnboardingCTA = ({
  onButtonClick,
  buttonLabel = 'Start Learning',
  variant = 'welcome',
  className = '',
  isLoading = false
}) => {
  const buttonClass = variant === 'form' ? 'submit-button-figma-new' : 'welcome-start-button';

  return (
    <>
      {/* Layered Gradient Backgrounds - Matching screenshot with 7 layers */}
      <div className={`layered-background-new ${className}`}>
        <div className='layer-new layer-1-new'></div>
        <div className='layer-new layer-2-new'></div>
        <div className='layer-new layer-3-new'></div>
        <div className='layer-new layer-4-new'></div>
        <div className='layer-new layer-5-new'></div>
        <div className='layer-new layer-6-new'></div>
        <div className='layer-new layer-7-new'></div>
      </div>

      {/* CTA Button - Updated according to Figma */}
      <button
        className={buttonClass}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!isLoading && onButtonClick) {
            onButtonClick(e);
          }
        }}
        type='button'
        disabled={isLoading}
        style={{ pointerEvents: 'auto' }}
      >
        {isLoading ? (
          <ClipLoader color='#ffffff' size={20} />
        ) : (
          buttonLabel
        )}
      </button>
    </>
  );
};

export default OnboardingCTA;

